import { breakpoints } from '@tcp/core/styles/themes/TCP/mediaQuery';

const CAROUSEL_OPTIONS = {
  accessibility: false,
  autoplay: false,
  arrows: true,
  centerMode: false,
  infinite: false,
  centerPadding: '0px',
  fade: false,
  speed: 200,
  swipeToSlide: false,
  lazyLoad: false,
  dots: false,
  swipe: true,
  variableWidth: true,
  responsive: [
    {
      breakpoint: parseInt(breakpoints.large, 10) - 1,
      settings: {
        arrows: false,
        swipeToSlide: true,
      },
    },
  ],
};

export default { CAROUSEL_OPTIONS };
